import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchContactsDone = (_, { payload }) => {
  return [
    ...payload,
  ];
};

const fetchContactByIdDone = (contacts, { payload }) => {
  return [
    ...contacts,
    payload,
  ];
};

const fetchContactServiceRequestssDone = (contacts, { payload }) => {
  return contacts.map(c => {
    if (c.id === payload.id) {
      return {
        ...c,
        service_requests: payload.serviceRequests,
      };
    }
    return c;
  });
};

const fetchContactNotesDone = (contacts, { payload }) => {
  return contacts.map(c => {
    if (c.id === payload.id) {
      return {
        ...c,
        notes: payload.notes,
      };
    }
    return c;
  });
};

const fetchContactDocumentsDone = (contacts, { payload }) => {
  return contacts.map(c => {
    if (c.id === payload.id) {
      return {
        ...c,
        documents: payload.documents,
      };
    }
    return c;
  });
};

const saveContactDone = (contacts, { payload }) => {
  return [
    ...contacts,
    payload,
  ];
};

const updateContactDone = (contacts, { payload }) => {
  return contacts.map( c => {
     if( c.id === payload.id){
       return payload
     }
     return c
  })
};

const saveContactNoteDone = (contacts, { payload }) => {
  return contacts.map(c => {
    if (c.id === payload.id) {
      return {
        ...c,
        notes: [
          ...c.notes,
          payload.note,
        ],
      };
    }
    return c;
  });
};

const deleteContactDone = (contacts, { payload }) =>{
  return contacts.filter( c => c.id !== payload);
}

const fetchedSuiteUsersAddToContactsDone = ( contacts, { payload }) => {
  let suiteUsers = payload;
  for(var i=0;i<suiteUsers.length;i++){
    let userExits = contacts.filter( a => a.id === suiteUsers[i].id).length > 0 ? true : false;
    if( userExits === true ){

    }else{
      contacts = [...contacts,suiteUsers[i]]
    }

  }
  return contacts
}

const initialState = [];

export default createReducer(initialState, {
  [TYPES.FETCH_CONTACTS_DONE]: fetchContactsDone,
  [TYPES.FETCH_CONTACT_BY_ID_DONE]: fetchContactByIdDone,
  [TYPES.FETCH_CONTACT_NOTES_DONE]: fetchContactNotesDone,
  [TYPES.FETCH_CONTACTS_DOCUMENTS_DONE]: fetchContactDocumentsDone,
  [TYPES.SAVE_CONTACT_DONE]: saveContactDone,
  [TYPES.UPDATE_CONTACT_DONE]:updateContactDone,
  [TYPES.SAVE_CONTACT_NOTE_DONE]: saveContactNoteDone,
  [TYPES.FETCH_CONTACT_SERVICE_REQUESTS_DONE]: fetchContactServiceRequestssDone,
  [TYPES.DELETE_CONTACT_DONE]:deleteContactDone,
  [TYPES.FETCHED_SUITE_USERS_ADD_TO_CONTACTS_DONE]:fetchedSuiteUsersAddToContactsDone
});
